<template>
  <div class="address-list">
    <ul>
      <li v-for="(item, index) of addressInfo" :key="index">
        <div class="wrapper">
          <div>
            <span>{{ item.name }}</span>
          </div>
          <div class="tel">
            <span>{{ item.tel }}</span>
          </div>
          <div class="control-box">
            <button class="delete" @click="deleteaddress(item.address_id)"></button>
            <button class="edit" @click="editaddress(item.address_id)"></button>
          </div>
        </div>
        <div class="address" @click="setAddres(item.address_id)">
          <div>
            <div><span>收货地址</span></div>
            <div class="default" v-if="item.is_default">默认地址</div>
          </div>
          <div class="arealist">
            <p>
              <span>{{ item.provinceName }}</span>
              <span>{{ item.cityName }}</span>
              <span>{{ item.countyName }}</span>
              <span>{{ item.townName }}</span>
            </p>
            <p>{{ item.address }}</p>
          </div>
        </div>
      </li>
    </ul>
    <div class="add-Addr"><button @click="addAddr">新建收货地址</button></div>
  </div>
</template>
<script>
import { deleteaddress, addresslist } from '@/api/address'
import { setAddressId, adType } from '@/utils/Address'
import scroll from '@/mixins/scroll'

export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.hash === '#payment' || to.hash === '#payment') {
        const content = vm.addressInfo.length > 0 ? '请选择地址' : '请添加地址'
        vm.$toast({
          message: content,
          duration: 3000
        })
      }
    })
  },
  data () {
    return {
      addressInfo: [],
      page: 0,
    };
  },
  mixins: [scroll],
  methods: {
    async getList () {
      const result = await addresslist({ page: this.page, size: 8 })
      if (result.data.data.addressList.data.length !== 0) {
        this.addressInfo = this.addressInfo.concat(result.data.data.addressList.data)
      } else {
        this.page === null
      }
    },
    async deleteaddress (id) {
      const result = await deleteaddress({ address_id: id })
      if (result.data.data.status) {
        this.addressInfo = this.addressInfo.filter((item) => {
          return item.address_id !== id
        })
        sessionStorage.removeItem("adid");
      }
      this.$toast(result.data.data.message)
    },
    editaddress (id) {
      const anchor = this.$route.hash || ''
      this.$router.replace({
        path: '/editaddress' + anchor,
        query: {
          type: "edit",
          adid: id
        }
      })
    },
    addAddr () {
      const anchor = this.$route.hash || ''
      this.$router.replace({
        path: '/editaddress' + anchor,
        query: {
          type: "add",
          adid: 0
        }
      })
    },
    setAddres (id) {
      const anchor = this.$route.hash
      if (anchor)
        setAddressId(id)
      // this.$router.replace({
      //   name: adType[anchor.substr(1)]
      // })
      this.$router.go(-1)
    },
  },
  created () {
    const anchor = this.$route.hash
    if (anchor) {
      this.$toast("请选择收货地址")
    }
  }
};
</script>
<style lang="scss" scoped>
.control-box {
  width: 0.8 rem;
}
.address-list {
  font-size: 0.28rem;
  padding-bottom: 2rem;
  ul {
    li {
      width: 6.68rem;
      border-radius: 10px;
      padding: 0.2rem;
      margin: 0.18rem;
      background: white;
    }
  }
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.1rem 0;
    span {
      font-weight: 700;
    }
    .delete {
      background: url('../../assets/icon/delete.png') no-repeat;
      width: 0.31rem;
      height: 0.31rem;
      background-size: 0.31rem;
      border: none;
    }
    .edit {
      background: url('../../assets/icon/edit.png') no-repeat;
      width: 0.31rem;
      height: 0.31rem;
      background-size: 0.31rem;
      border: none;
      margin-left: 0.1rem;
    }
    .tel {
      text-align: left;
      width: 4.1rem;
    }
  }
  .address {
    @extend .wrapper;
    align-items: baseline;
  }
  .default {
    //   width: 0.95rem;
    border-radius: 30px;
    font-size: 0.2rem;
    padding: 0.02rem 0.05rem;
    border: 1px solid #ff6161;
    color: #ff6161;
    text-align: center;
    margin-top: 0.05rem;
  }
  .add-Addr {
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0.2rem;
    width: 100%;
    button {
      border: none;
      border-radius: 30px;
      padding: 0.3rem 0;
      width: 5rem;
      background: #ff6161;
      color: white;
    }
  }
  .arealist {
    width: 5.4rem;
    p {
      margin: 0.05rem;
      span {
        margin-right: 0.1rem;
      }
    }
  }
}
</style>
